import React, {PureComponent} from 'react';

import {Button, Classes, MenuItem, Overlay, Callout} from "@blueprintjs/core";
import {Select} from "@blueprintjs/select";
import http from "../../services/httpService";
import {default as authService} from "../../services/authService";
import toastr from "toastr";


export default class CampaignDetailsModal extends PureComponent {
    state = {
        overlayIsOpen: false,
    }
    handleClose = () => {
        this.setState({
            overlayIsOpen: false
        })
    }

    componentDidMount() {
        this.setState({
            overlayIsOpen: this.props.showModal
        })
    }

    componentDidUpdate() {
        if (this.state.overlayIsOpen !== this.props.showModal) {
            this.setState({
                oldShortCode: this.props.oldShortCode,
                overlayIsOpen: this.props.showModal
            })
        }
    }


    domainItemSelect = (item) => {
        this.setState({selectedDomain: item})
    }


    render() {
        //console.log('this.props.summary: ', this.props.summary)
        return (
            <Overlay
                onClose={this.props.handleClose}
                className={Classes.OVERLAY_SCROLL_CONTAINER + ' customize-short-link-modal'}
                isOpen={this.state.overlayIsOpen}

                style={{
                    display: 'flex',
                    flex: 1,
                    justifyContent: 'center',
                    alignItems: 'center',
                }}
            >
                <div className="modal-field"
                     style={{width: this.props.width || '60%', maxWidth: this.props.maxWidth || '100%'}}>

                    <div className="modal-header">
                        <h2>Campaign Details</h2>
                        <span className='close-modal' onClick={() => {
                            this.props.handleClose()
                        }}>×</span>
                    </div>
                    <div className="onboarding-panel viber-modal-container">
                        <div className="info-segment-container">
                            <p className='text-bold'>ID</p>
                            <p>{this.props.campaignId || ''}</p>
                        </div>
                        <div className="info-segment-container">
                            <p className='text-bold'>Sent From</p>
                            {
                                this.props.sentFrom && this.props.sentFrom.length > 0 ?
                                    <React.Fragment>
                                        {Array.isArray(this.props.sentFrom) ?
                                            this.props.sentFrom.map(pageName =>
                                                <React.Fragment>
                                                    <p>{pageName}</p>
                                                </React.Fragment>
                                            )
                                            : <p>{this.props.sentFrom}</p>

                                        }

                                    </React.Fragment> : ''
                            }
                        </div>
                        <div className="info-segment-container">
                            <p className='text-bold'>Send Time</p>
                            <p>{this.props.sendTime.date || ''} <span>{this.props.sendTime.time || ''}</span></p>
                        </div>
                        <div className="info-segment-container">
                            <p className='text-bold'>Message</p>
                            <p>{this.props.message || ''}</p>
                        </div>
                        <div className="info-segment-container">
                            <p className="text-bold">Segments</p>
                            <div className="info-tags-container">
                                { this.props.segments && this.props.segments.length ?
                                    this.props.segments.map(segment => <span
                                        key={segment}
                                        className='bp3-tag custom-tag'>{
                                        segment.toLowerCase()}
                                    </span>)
                                        :
                                        ''
                                }
                            </div>
                        </div>
                        <div className="info-segment-container">
                            <p className="text-bold">Summary</p>
                            <div className="info-tags-container">
                                <div className="summary-container">

                                    <div className="summary-info">
                                        <p>Delivered:</p>
                                        <p>{
                                            this.props.summary.delivered || ''}
                                            <span>({this.props.summary.deliveredPercentage || ''})</span></p>
                                    </div>
                                    <div className="summary-info">
                                        <p>Not Delivered:</p>
                                        <p>{this.props.summary.notDelivered || ''}
                                            <span>({this.props.summary.notDeliveredPercentage || ''})</span></p>
                                    </div>
                                    {this.props.summary && this.props.summary.buffered && this.props.summary.buffered !== '' ?
                                        <div className="summary-info">
                                            <p>Buffered:</p>
                                            <p>0 <span>(0%)</span></p>
                                        </div>
                                        : ''}
                                    {this.props.summary && this.props.summary.clicked && this.props.summary.clicked !== '' ?
                                        <div className="summary-info">
                                            <p>Clicked:</p>
                                            <p>{this.props.summary.clicked}
                                                <span> ({this.props.summary.clickedPercent})</span></p>
                                        </div>
                                        :
                                        ''
                                    }
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </Overlay>
        )
    }
}